import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import ResourcesLeft from './Resources_Left'

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="COMPUTER CENTER" />
            <section className="team-area fix p-relative pt-120 pb-80  mt-5 mb-5">
                <div className="container">
                    <div className="lower-content">

                        <Row>
                            <Col md={3} className='c-left custom-padding-color mb-4'>
                                <ResourcesLeft activeIndex={1} />
                            </Col>

                            <Col md={9} className='c-right c-lineheight2dot5 text-dark'>
                                <h3 className='c-headline mb-3'>COMPUTER CENTER </h3>
                                <p>Computer Centre (CC) is responsible for maintaining the software developments, central computing and networking infrastructure of IIT Tirupati. The computing facility primarily involves PC and workstation labs running both general and special-purpose software which used for holding lab classes of different departments. Networking services provided by CC includes wired and wireless internet access spanning the entire institute, a centralized mail messaging service, and several other ancillary services. </p>

                                <h3 className='c-headline mt-5 mb-3'>SOFTWARES</h3>
                                <p>Computer Center (CC) supports the institute with different licensed software to avoid the usage of pirated or unlicensed version of the software. As part of the policy, the institute provides basic software to faculty and staff such as Windows OS, PDF Editor, Microsoft Apps and Kaspersky Antivirus, and Microsoft Apps for Students. More details about software can be found <Link className='text-orange' to="https://cc.iittp.ac.in/software" target="_blank" > here </Link></p>

                                <h3 className='c-headline mt-5 mb-3'>Networks</h3>
                                <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Dedicated high speed leased internet with Wi-Fi connectivity.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Acquired 1Gbps line from NKN. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Provided Wi-Fi from Academic building to Guest house, Boys and Girls hostels by point-to-point RF transceivers with more than 100 mbps speed.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Fully networked Academic campus.</li>
                                </ul>


                                <h3 className='c-headline mt-5 mb-3'>Computers</h3>
                                <p>Computer Center also has 3 labs to cater the need of the entire institute. </p>
                                <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />CS Lab1 has 64 seater capacity.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />CS Lab2 has 55 seater capacity. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />IMac Lab has 25 seater capacity.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />All labs are having state-of-the-art facilities including latest intel processor based systems with dual booting OS (Windows and Linux) </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Each sysem has AutoCAD, Matlab, Creo, COMSOL, ANSYS, Microsoft Office and other software installed. </li>
                                </ul>

                                <p>For more details, please visit <Link className='text-orange' to="https://cc.iittp.ac.in/computers" target="_blank" > here </Link></p>

                     
                            </Col>
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;